const jsonFileCreationMenu = [
    {
        icon: "upload_file",
        key: "configuration.JSONFileCreation",
        name: "JSON File Creation",
        url: "home/app/configurations/JSONFileCreation",
        description: "JSON File Creation",
        productionReady: false,
        disabled: false,
      },
  ];
  
  export { jsonFileCreationMenu };
  